import axios from 'axios';

axios.defaults.baseURL = BASEURL;

export default axios;
